// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { amountToCurrencyString } from '@tectonics/prs/money';
import { getCountry, useIncomingPayment } from '@tectonics/prs/incoming-payment';
import { getMoneyFormat } from '@tectonics/look-and-feel/shopify/commons/money-format';
import { getReceiptAmountLocalTotal } from '@tectonics/prs/receipts/receipt';
import { useCurrentReceipt } from '@tectonics/prs/receipts';

export function TicketAmount(): Node {
  return (
    <Root>
      <Term>Valor</Term>
      <Definition data-testid="display-total-amount">{DisplayTotalAmount()}</Definition>
    </Root>
  );
}

function DisplayTotalAmount(): Node {
  const incomingPayment = useIncomingPayment();
  const receipt = useCurrentReceipt();
  const decimalFormat = getMoneyFormat(getCountry(incomingPayment));
  const formatAmount = amountToCurrencyString(decimalFormat);
  return formatAmount(getReceiptAmountLocalTotal(receipt));
}


const Root = styled.dl`
  text-align: center;
  padding: 1.2em;
`;

const Term = styled.dt`
  font-family: ${props => props.theme.fontFamily.sansSerif};
  font-size: 0.9em;
`;

const Definition = styled.dd`
  font-family: ${props => props.theme.fontFamily.display};
  font-size: 1.3em;
  font-weight: bold;
`;
